<template>
    <van-popup v-model:show="show" @close="close" position="center" :style="{
        minWidth: '70%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        zIndex: '10000'
    }">
        <div class="popupContainer">
            <div class="closeIcon">
                <img src="@/assets/common/close_icon.png" alt="" @click="close">
            </div>
            <div class="bannerImg">
                <img src="@/assets/common/pwa_update_banner.png" alt="">
            </div>
            <div style="padding: 0 20px;">
                <div class="detailsBg">
                    <div class="infoText">
                        <p style="white-space: pre-line;">
                            {{ activityInfo }}</p>
                    </div>
                </div>
                <div class="bonusBar">
                    <img src="@/assets/common/pwa_update_icon1.png" alt="">
                    <div>{{ $t('pwa.bonuses') }} <span>R$ {{ rewardCoin }}</span></div>
                </div>

                <van-row style="padding: 5px 0 15px;">
                    <van-col span="18" class="alignment">
                        <div class="linkBtn">
                            <img src="@/assets/common/pwa_update_icon2.png" alt="">
                            <div @click="handlePlayStore">{{ $t('pwa.updateNow') }}</div>
                        </div>
                    </van-col>
                    <van-col span="6" class="alignment">
                        <div class="serviceIcon" @click="handleContact">
                            <img src="@/assets/common/0029_kefu2_bai.png" alt="">
                        </div>
                    </van-col>
                </van-row>
            </div>

        </div>
    </van-popup>
    <ContactServicePopup ref="contactRef" />
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, computed, defineExpose, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/user'
import ContactServicePopup from '@/view/profile/contactServicePopup.vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import {
  openPopup,
  closePopup,
  showError,
  showSuccess,
  openContactPopup,
  goToPlayStore
} from '@/view/components/supportFunction'

const { t } = useI18n()
const emits = defineEmits(['close', 'success', 'error'])

const userStore = useUserStore()
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const contactRef = ref()

const activityInfo = computed(() => userStore?.PWAConvertData?.config?.popupMessage)
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const rewardCoin = computed(() => userStore?.PWAConvertData?.config?.rewardCoin)
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
const timeDuration = computed(() => userStore?.PWAConvertData?.config?.popupDuration)
const pwaID = computed(() => userStore?.PWAConvertData?.config?.Id)
const pwaDomainInfo = computed(() => userStore?.PWAdomainInfo)

const params = {
  show,
  contactRef,
  statusRef,
  loadingRef,
  toastContent,
  isSuccess,
  userStore,
  isOpen,
  canReceivedRewards: canRecievedRewards,
  timeDuration,
  pwaID,
  pwaDomainInfo,
  emits,
  t
}

const open = () => openPopup(params)
const close = () => closePopup(params)
const handleContact = () => openContactPopup(params)
const handlePlayStore = () => goToPlayStore(params)

defineExpose({ open, close })
</script>

<style scoped>
.popupContainer {
    background-image: linear-gradient(147deg, #FEFCE1 0%, #DA8D4E 100%);
    padding: 10px;
    border-radius: 25px;
    width: 70%;
    overflow: hidden;
}

.van-overlay {
    z-index: 9999 !important;
}

.closeIcon {
    display: flex;
    justify-content: right;
}

.closeIcon img {
    width: 25px;
    padding: 2px;
    background-color: #000;
    border-radius: 30px;
}

.bannerImg {
    padding: 5px;
}

.bannerImg img {
    width: 100%;
}

.detailsBg {
    background: url('@/assets/common/pwa_update_background1.png');
    background-size: cover;
    background-repeat: repeat;
    border: 2px solid #f7d9b5;
    border-radius: 10px;
    padding: 15px 10px;
}

.infoText {
    color: #fff;
    font-size: 14px;
}

.bonusBar {
    background: #00000014;
    color: #000000a6;
    border-radius: 30px;
    padding: 15px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
}

.bonusBar span {
    color: #7800BB;
    font-size: 17px;
}

.bonusBar img {
    width: 25px;
    padding-right: 10px;
}

.linkBtn {
    background-image: linear-gradient(180deg, #F39A4F 0%, #78340F 100%);
    border: 1.5px solid rgba(249, 196, 134, 1);
    padding: 15px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    color: #FFFFFF;
    font-size: 15px;
    width: 90%;
}

.linkBtn img {
    width: 25px;
    padding-right: 10px;
}

.serviceIcon {
    display: flex;
    justify-content: center;
    align-items: center;
}

.serviceIcon img {
    width: 40%;
    padding: 12px;
    border-radius: 30px;
    background: #00000040;
}

.alignment {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>